import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--cta",
  "use": "icon-arrow--cta-usage",
  "viewBox": "0 0 6 9",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 9\" id=\"icon-arrow--cta\"><path d=\"M1.071 8.424a.242.242 0 0 0 .172.076.23.23 0 0 0 .171-.076l3.515-3.741A.26.26 0 0 0 5 4.5a.273.273 0 0 0-.071-.183L1.414.576A.242.242 0 0 0 1.243.5a.23.23 0 0 0-.172.076A.26.26 0 0 0 1 .758a.273.273 0 0 0 .071.183L4.414 4.5 1.07 8.06a.267.267 0 0 0-.07.181c0 .069.025.134.07.182Z\" fill=\"#fff\" stroke=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol